var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.cityDetail.cityName === '辉县市' && _vm.$route.query.remark)?_c('CJGG_HXS'):(_vm.cityDetail.cityName === '获嘉县' && _vm.$route.query.remark)?_c('CJGG_HJX'):(_vm.cityDetail.cityName === '许昌市' && _vm.$route.query.remark)?_c('CJGG_XCS'):_c('CJGG_DEFAULT')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }